import { InputField, RadioField, SelectField } from "@/components";
import LocationHierarchySelect from "@/components/LocationHierarchySelect";
import {
  optionsAllocationStatus,
  optionsBucketWiseLoadBalancing,
  optionsCollectorGender,
  optionsCollectorSegment,
  optionsItinerary,
  optionsPerformanceRating,
} from "@/partial/campaign/constant";
import { CampaignForm } from "@/partial/campaign/types";
import { Control, UseFormWatch } from "react-hook-form";
import { Fragment } from "react/jsx-runtime";
import { FlexField } from "../channel/styles";
import usePortfolioCategory from "@/services/hooks/portfolio/usePortfolio";
import { useMemo } from "react";
import MultilevelSelectField from "@/components/MultilevelSelectField";

interface FieldProps {
  indexChannel: number;
  control: Control<CampaignForm>;
  watch: UseFormWatch<CampaignForm>;
  disabled: boolean;
}

export const Field = ({ indexChannel, control, disabled }: FieldProps) => {
  const { data: portfolioCategory } = usePortfolioCategory();

  const portfolioCategoryOptions = useMemo(() => {
    if (!portfolioCategory) return [];
    return portfolioCategory.map((item) => ({
      label: item.name,
      value: item.name,
      children: item.items.map((child) => ({
        label: child.value,
        value: child.id,
      })),
    }));
  }, [portfolioCategory]);

  return (
    <Fragment>
      <FlexField>
        <MultilevelSelectField
          name={`campaign_channels[${indexChannel}].allocation_status`}
          control={control}
          options={optionsAllocationStatus}
          onSelected={() => {}}
          placeholder="Select Allocation Status"
          formLabel="Allocation Status"
          isMultiple
          disabled={disabled}
        />
        <InputField
          name={`campaign_channels[${indexChannel}].allocation_limit`}
          control={control}
          placeholder="120"
          label="Allocation Limit"
          numberOnly
          disabled={disabled}
        />
        <MultilevelSelectField
          name={`campaign_channels[${indexChannel}].portfolio`}
          control={control}
          options={portfolioCategoryOptions}
          placeholder="Select Portfolio"
          formLabel="Portfolio"
          disabled={disabled}
        />
        <LocationHierarchySelect
          control={control}
          name={`campaign_channels[${indexChannel}].location`}
          formLabel="Location"
          placeholder="Select Location"
          disabled={disabled}
        />
        <RadioField
          name={`campaign_channels[${indexChannel}].bucket_wise_load_balancing`}
          control={control}
          label="Bucket Wise Load Balancing"
          radioValues={optionsBucketWiseLoadBalancing}
          className="bucket-radio"
          disabled={disabled}
        />
        <InputField
          name={`campaign_channels[${indexChannel}].km_range`}
          control={control}
          placeholder="Enter KM Range"
          label="KM Range (+15%)"
          type="number"
          disabled={disabled}
        />
        <InputField
          name={`campaign_channels[${indexChannel}].acr`}
          control={control}
          placeholder="Enter ACR"
          label="ACR (+10%)"
          type="number"
          disabled={disabled}
        />
        <SelectField
          name={`campaign_channels[${indexChannel}].collector_segment`}
          options={optionsCollectorSegment}
          control={control}
          placeholder="Select Collector Segment"
          label="Collector Segment"
          isMultiple
          disabled={disabled}
        />
        <SelectField
          name={`campaign_channels[${indexChannel}].collector_gender`}
          options={optionsCollectorGender}
          control={control}
          placeholder="Select Collector Gender"
          label="Collector Gender"
          disabled={disabled}
        />
        <SelectField
          name={`campaign_channels[${indexChannel}].performance_rating`}
          options={optionsPerformanceRating}
          control={control}
          placeholder="Select Performance Rating"
          label="Performance Rating"
          isMultiple
          disabled={disabled}
        />
        <SelectField
          name={`campaign_channels[${indexChannel}].itinerary`}
          options={optionsItinerary}
          control={control}
          placeholder="Select Itinerary"
          label="Itinerary"
          isMultiple
          disabled={disabled}
        />
      </FlexField>
    </Fragment>
  );
};

export default Field;
